import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import clsx from 'clsx';

import api from '../../common/apiService';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Grid,
  Snackbar,
  Hidden,
  CircularProgress,
  TopBar,
  Typography
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import { parseISO, format } from 'date-fns';
import { Toolbar, UsersList, Summary, DishSummary } from './components';
import config from '../../config/config.json';
import withAlert from '../../hoc/withAlert';

import {
  initPage,
  getRequestErrorsByPageSelector,
  getPageReadyByPageSelector
} from '../../store/api';

import {
  loadCheckin,
  getTicketCheckinUsers,
  checkCouponsByUserAndEating,
  deleteCouponsByUserAndEating
} from '../../store/ticket';

import { getMealSelector } from '../../store/meal';

// import { animateHeart, heartStyles } from '../../helpers/animation';

const useStyles = makeStyles(theme => ({
  toolbar: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
  // ...heartStyles
}));

const Chekin = props => {
  // Заберем из HOC нужные методы для показа алерта
  const {
    className,
    setSnackMessage,
    setSnackType,
    setOpenSnack,
    ...rest
  } = props;

  const classes = useStyles();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedMeal, setSelectedMeal] = useState(
    _.filter(config.mealsTypes, ['name', 'Завтрак'])[0].id
  );

  // const [users, setUsers] = useState([]);
  const [couponsCount, setCouponsCount] = useState({
    allcoupons: 0,
    allcouponsStaff: 0,
    allcouponsCustomers: 0,
    allcouponsChecked: 0,
    allcouponsCheckedStaff: 0,
    allcouponsCheckedCustomers: 0
  });
  // const [usersServer, setUsersServer] = useState([]);

  const dispatch = useDispatch();
  // const eating = useSelector(getEatingSelector);

  const pageReady = useSelector(
    getPageReadyByPageSelector(props.location.pathname)
  );

  //   console.log('coupons',coupons);
  const mealData = useSelector(getMealSelector);
  const usersData = useSelector(getTicketCheckinUsers);

  useEffect(() => {
    const getData = async () => {
      // await dispatch(loadMeal());
      await initPage(props.location.pathname, dispatch);
      // console.log('selectedDate',selectedDate);
      // await dispatch(loadTicketsByDate(format(selectedDate,'dd.MM.yyyy')));
    };
    getData();
  }, [dispatch]);

  const [users, setUsers] = useState([]);

  useEffect(() => {
    // console.log('useEffect usersData',usersData);
    setUsers(usersData);
  }, [usersData]);
  // useEffect(() => {
  //   const getData = async () => {
  //       // await dispatch(loadMeal());
  //       console.log('selectedDate',selectedDate);
  //       await dispatch(loadCouponsByDate(format(selectedDate,'dd.MM.yyyy')));

  //   };
  //   if(pageReady){
  //     getData();
  //   }
  // }, [pageReady]);

  // const getData = async () => {
  //   // console.log('selectedMeal',selectedMeal);
  //   const usersApi = await api.getChekinUsers(selectedDate, selectedMeal);
  //   console.log('usersApi',usersApi);

  //   // console.log('preparedUsers',preparedUsers);
  //   if(usersApi.length > 0){

  //     const preparedUsers = usersApi.map(c => {
  //       return {
  //       user_id: c.Customer.id,
  //       user_name: `${c.Customer.surname} ${c.Customer.name}`,
  //       customertype_id:c.customertype_id,
  //       eating_id: c.Eventeating.eating_id,
  //       meal_id: c.meal_id,
  //       amount: c.amount,
  //       checked: ! (c.couponeatingchecked.length < c.amount),
  //       // couponsChecked: c.couponeatingchecked
  //     }
  //   })

  // // const test = _(preparedUsers)
  //     // .groupBy('eating_id')
  //     // .reduce( function(result, eating, id){

  //     //   result[id] = _(eating)
  //     const res = _(preparedUsers)
  //             .groupBy('user_id')
  //             .reduce( function(res, user, id){
  //               const u = {}
  //               // res[id] = {}
  //               u['user_id'] = id
  //               u['user_name'] = user[0].user_name
  //               u['customertype_id'] = user[0].customertype_id
  //               u['checked'] = user.every( (u) => u.checked )
  //               // res[id]['couponsChecked'] = user.reduce((agg, coupon),[])
  //               u['meals'] = user.map(u=> {
  //                 // console.log('mealobj',mealData.filter(m => m.id === u.meal_id));
  //                 return {
  //                 mealId: u.meal_id,
  //                 checked: u.checked,
  //                 amount: u.amount,
  //                 mealName: mealData.filter(m => m.id === u.meal_id)[0].name
  //               }})
  //               // res[id]['user_name'] = user[0].user_name
  //                 // console.log('user',user);
  //               // const mealId = getMealId(id)
  //               // res[mealId] = _.sumBy(meal, 'amount')
  //               res.push(u)
  //               return res
  //             }, [])

  //     //   return result;
  //     // }, {}
  //     // )
  //     console.log('res', res);
  //     setUsers(res)

  //   }
  // // setUsers(usersApi)
  //   // setUsers(prepareApiUsers(dummyUsers))
  //   // setUsers()
  //   // const res = prepareApiUsers(usersApi)
  //   // console.log('reportApi prepareApiUsers',res);
  //   //  const usersPrepared = prepareApiUsers(usersApi)
  //   //  return usersPrepared
  // };

  // const prepareApiUsers = (apiUsers) => {
  //   // console.log('apiUsers', apiUsers);
  //   const apiUsersPrepared = _.map(apiUsers, (value, key) => {
  //     return makeCouponsList(
  //       {
  //         user: {
  //           id: value.Customer.id,
  //           name: `${value.Customer.surname} ${value.Customer.name}`,
  //           type: value.customertype_id === config.employeeType ? 1 : 0,
  //         },
  //         coupon: {
  //           amount: value.amount,
  //           id: value.id
  //         },
  //         meal: mealData.filter(m => m.id === value.meal_id)[0],
  //         checkedCoupons: value.couponeatingchecked
  //       }
  //     )

  //   });

  //   calculateCoupons(apiUsersPrepared)
  //   return apiUsersPrepared
  // }

  // const makeCouponsList = (coupon) => {
  //   return {
  //     user: coupon.user,
  //     coupon: coupon.coupon,
  //     meal: coupon.meal ? coupon.meal : '',
  //     checkedCoupons: coupon.checkedCoupons,
  //     allChecked: coupon.coupon.amount === coupon.checkedCoupons.length ? false : true,
  //     couponsList: _.range(0, coupon.coupon.amount).map(num => (
  //       {
  //         id: num,
  //         userId: coupon.user.id,
  //         couponId: coupon.coupon.id,
  //         checked: coupon.checkedCoupons.length > num,
  //         checkedCouponId: coupon.checkedCoupons.length > num ? coupon.checkedCoupons[num].id : null,

  //       }
  //     ))
  //   }
  // }

  const addCheckedCoupon = (coupon, checkedCoupon) => {
    // coupon.checkedCoupons = coupon.checkedCoupons.push(checkedCoupon)
    coupon.checkedCoupons.push(checkedCoupon);
    // return makeCouponsList(coupon)
  };
  // function(ch) { return !o.active; }
  const deleteCheckedCoupon = (coupon, checkedCouponId) => {
    // console.log('deleteCheckedCoupon coupon,  checkedCouponId', coupon, checkedCouponId);
    // coupon.checkedCoupons = coupon.checkedCoupons.push(checkedCoupon)
    coupon.checkedCoupons = _.filter(coupon.checkedCoupons, ch => {
      return ch.id != checkedCouponId;
    });
    // return makeCouponsList(coupon)
  };

  // const dummyUsers = [
  //   {
  //     user: {
  //       id: 121,
  //       name: 'Артем Иванов',
  //       type: 0,
  //     },
  //     coupon: {
  //       amount: 1,
  //       id: 1
  //     },
  //     checkedCoupons: []
  //   }
  // ]

  // const [hearts, setHearts] = useState([]);
  // const heartsAmount = 20;

  // useEffect(() => {
  //   for (let i = 0; i < heartsAmount; i++) {
  //     animateHeart(`heart${i}`);
  //   }
  // }, [hearts]);

  useEffect(() => {
    // Получим списки сессий и пользователей
    // const usersNew = getData();
    // console.log('usersNew useEffect',usersNew);
    const getData = async () => {
      await dispatch(loadCheckin(selectedDate, selectedMeal));
    };

    if (pageReady) {
      getData();
      // const usersApi = useSelector(loadCheckin(selectedDate, selectedMeal))
      // setUsers(usersApi);
      // setUsers(getData());

      // const browserWidth = document.documentElement.clientWidth;
      // const reds = [
      //   '#ff001a',
      //   '#ff1129',
      //   '#ee0018',
      //   '#ff3348',
      //   '#990010',
      //   '#ff6676',
      //   '#ff4457'
      // ];

      // const maxOffset = Math.ceil(browserWidth / heartsAmount);
      // let newHearts = [];
      // for (let i = 0; i < heartsAmount; i++) {
      //   const marginLeft =
      //     i * maxOffset + Math.floor(Math.random() * maxOffset);
      //   const color = Math.floor(Math.random() * reds.length);
      //   const size = Math.floor(Math.random() * 3);
      //   // newHearts.push({id:i,left:marginLeft,color:`classes.color${color}`})
      //   newHearts.push({
      //     id: i,
      //     left: marginLeft,
      //     color: `color${color}`,
      //     size: `size${size}`
      //   });
      // }

      // setHearts(newHearts);
    }
    // calculateCoupons()
  }, [pageReady]);

  const calculateCoupons = coupons => {
    // console.log('users calculateCoupons', coupons);
    const couponsCountNew = {
      allcoupons: _.sumBy(coupons, 'coupon.amount'),
      allcouponsStaff: _.sumBy(
        _.filter(coupons, ['user.type', 1]),
        'coupon.amount'
      ),
      allcouponsCustomers: _.sumBy(
        _.filter(coupons, ['user.type', 0]),
        'coupon.amount'
      ),
      allcouponsChecked: _.sumBy(coupons, function(o) {
        return o.checkedCoupons.length;
      }),
      allcouponsCheckedStaff: _.sumBy(
        _.filter(coupons, ['user.type', 1]),
        function(o) {
          return o.checkedCoupons.length;
        }
      ),
      allcouponsCheckedCustomers: _.sumBy(
        _.filter(coupons, ['user.type', 0]),
        function(o) {
          return o.checkedCoupons.length;
        }
      )
    };
    setCouponsCount(couponsCountNew);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const handleMealChange = meal => {
    // console.log('handleMealChange', meal);
    setSelectedMeal(meal);
  };

  const handleMakeReport = async () => {
    // setUsers(getData());
    await dispatch(loadCheckin(selectedDate, selectedMeal));
  };

  const handleChange = async ({ userId, checked }) => {
    // console.log('handleChange checked',userId, checked);
    if (checked === false) {
      await dispatch(
        checkCouponsByUserAndEating(userId, selectedDate, selectedMeal)
      );
    } else {
      await dispatch(
        deleteCouponsByUserAndEating(userId, selectedDate, selectedMeal)
      );
    }
  };

  // const handleChange = async (coupon, checked) => {

  //   // console.log('handleChange chekin', coupon, checked);
  //   // setChecked(event.target.checked);
  //   if (checked === true) {
  //     let checkedCouponNew = {}
  //     try {
  //       checkedCouponNew = await api.createCheckedCoupon(coupon.couponId, coupon.userId);
  //     }
  //     catch (error) {
  //       setSnackMessage(`Ошибка: ${error}`)
  //       setSnackType('error')
  //       setOpenSnack(true)
  //       return
  //     }
  //     // console.log('checkedCouponNew', checkedCouponNew);
  //     const usersNew = _.map(users, (value, key) => {
  //       return value.user.id === coupon.userId && value.coupon.id === coupon.couponId ? addCheckedCoupon(value, checkedCouponNew) : value
  //     });
  //     // console.log('usersNew', usersNew);
  //     // setUsers(usersNew)
  //     calculateCoupons(usersNew)
  //   }
  //   else {
  //     let res = ''
  //     try {
  //       const res = await api.deleteCheckedCoupon(coupon.checkedCouponId, coupon.couponId, coupon.userId);
  //     }
  //     catch (error) {
  //       setSnackMessage(`Ошибка: ${error}`)
  //       setSnackType('error')
  //       setOpenSnack(true)
  //       return
  //     }
  //     const usersNew = _.map(users, (value, key) => {
  //       return value.user.id === coupon.userId && value.coupon.id === coupon.couponId ? deleteCheckedCoupon(value, coupon.checkedCouponId) : value
  //     });
  //     // console.log('usersNew', usersNew);
  //     // setUsers(usersNew)
  //     calculateCoupons(usersNew)

  //   }
  // };

  const [couponStateFilter, setCouponStateFilter] = React.useState(() => 1);
  const [customerTypeFilter, setCustomerTypeFilter] = React.useState(() => 2);

  const handleCouponStateFilter = state => {
    setCouponStateFilter(state);
  };

  const handleCustomerTypeFilter = state => {
    setCustomerTypeFilter(state);
  };

  // console.log('users', users);

  return (
    <React.Fragment>
      {pageReady === false && (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <CircularProgress disableShrink size={56} />
        </div>
      )}

      <div className={classes.toolbar}>
        {/* {hearts.length > 0 &&
          hearts.map((h, ind) => (
            <div
              id={`heart${h.id}`}
              key={h.id}
              className={clsx(
                classes.heartShape,
                classes[h.color],
                classes[h.size]
              )}
              style={{ left: h.left }}></div>
          ))} */}

        <Toolbar
          date={selectedDate}
          meal={selectedMeal}
          onDateChange={handleDateChange}
          onMealChange={handleMealChange}
          onMakeReport={handleMakeReport}
          onCouponStateFilter={handleCouponStateFilter}
          couponStateFilter={couponStateFilter}
          onCustomerTypeFilter={handleCustomerTypeFilter}
          customerTypeFilter={customerTypeFilter}
          id={'toolbar'}
        />
        <div className={classes.content}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="flex-start"
            spacing={2}>
            {/* <Grid item sm={6} xs={12}>
              <Typography variant="h4" style={{ color: 'red' }}>
                ❤️❤️ C днем рождения ❤️❤️{' '}
              </Typography>
            </Grid> */}

            <Hidden smUp>
              <Grid item sm={6} xs={12}>
                <Summary />
              </Grid>
            </Hidden>

            <Hidden smUp>
              <Grid item sm={6} xs={12}>
                <DishSummary />
              </Grid>
            </Hidden>

            <Grid item sm={6} xs={12}>
              {pageReady !== false && users && users.length > 0 && (
                <UsersList
                  users={users}
                  onChange={handleChange}
                  couponStateFilter={couponStateFilter}
                  customerTypeFilter={customerTypeFilter}
                />
              )}
            </Grid>
            <Hidden xsDown>
              <Grid
                item
                sm={6}
                xs={1}
                style={{
                  position: '-webkit-sticky',
                  position: 'sticky',
                  top: 0
                }}>
                <Summary couponsCount={couponsCount} />
              </Grid>
            </Hidden>
          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withAlert(Chekin);
